export enum eEmailStatus {
    NOT_INITIAL = 0,
    CREATE_NEW = 1,
    REJECT = 2,
    APPROVED = 3,
    SENDING = 4,
    SUCCESS = 5,
}